/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const ArrowLeftOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.25 12H3.75m0 0 6.75-6.75M3.75 12l6.75 6.75"
})); // Fill


const ArrowLeftFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M21 11.999a.751.751 0 0 1-.75.75h-9v6c0 .148-.04.293-.12.416-.09.124-.2.22-.34.278a.768.768 0 0 1-.82-.16l-6.75-6.75c-.15-.142-.22-.334-.22-.534s.07-.392.22-.534l6.75-6.75c.1-.102.24-.171.38-.2.15-.027.3-.014.44.04.14.058.25.154.34.278.08.123.12.268.12.416v6h9a.751.751 0 0 1 .75.75z"
})); // DuoTone


const ArrowLeftDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.25 12H3.75m0 0 6.75-6.75M3.75 12l6.75 6.75"
}));
/**
  Icon ArrowLeftIcon in arrows group
*/


export const ArrowLeftIcon = createIcon('ArrowLeftIcon', 'arrow-left', 'arrows', ArrowLeftOutline, ArrowLeftFill, ArrowLeftDuotone, "0 0 24 24");